import {observer} from 'mobx-react';
import React from 'react';
import {RelatedProduct} from './related-products';
import RelatedProductItemImage from './image-fallback/related-product-item-image';

type Props = {
    product: RelatedProduct;
    onImageUnavailable: (productId: number) => void;
};

const ProductItem: React.FC<Props> = observer(({product, onImageUnavailable}) => {
    const {title, link, price} = product;
    const formattedPrice = `$${price.toFixed(2)}`;

    return (
        <a
            href={link}
            className="related-product-item"
            aria-label={`${title}, ${formattedPrice}`}
        >
            <RelatedProductItemImage
                product={product}
                onUnavailable={onImageUnavailable}
            />
            <div className="related-product-item-title">{title}</div>
            <div className="related-product-item-price">{formattedPrice}</div>
        </a>
    );
});

export default ProductItem;
